import { BrowserModule, Meta, Title  } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { DatePipe } from '@angular/common';
import {InputTextModule} from 'primeng/inputtext';

import {RatingModule} from 'primeng/rating';



import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { StudentProfileComponent } from './student-profile/student-profile.component';
import { MyCourseComponent } from './my-course/my-course.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { HomeComponent } from './home/home.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {CalendarModule} from 'primeng/calendar';


import {ButtonModule} from 'primeng/button';
import {AccordionModule} from 'primeng/accordion';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CountToModule } from 'angular-count-to';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SessionClient } from './configration/sessionclient.storage';
import {DialogModule} from 'primeng/dialog';
import {TabViewModule} from 'primeng/tabview';
import { StudentLearningComponent } from './student-learning/student-learning.component';
import { StudentEnrollComponent } from './student-enroll/student-enroll.component';
import { StudentDashboardComponent } from './student-dashboard/student-dashboard.component';
import { Interceptor, HTTPStatus } from './app.interceptor';
import {CheckboxModule} from 'primeng/checkbox';
import {RadioButtonModule} from 'primeng/radiobutton';
import {TableModule} from 'primeng/table';
import { RazorpayPaymentComponent } from './razorpay-payment/razorpay-payment.component';
import {CalendarModule as PrimengCalender} from 'primeng/calendar';
import {LightboxModule} from 'primeng/lightbox';
import {SelectButtonModule} from 'primeng/selectbutton';


// import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

import {DropdownModule} from 'primeng/dropdown';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { NotificationComponent } from './notification/notification.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
// import { ClipboardModule, ClipboardService } from 'ngx-clipboard';
import { MessageService } from 'primeng-lts/api';
import {ToastModule} from 'primeng/toast';
import { FestivalDetailsComponent } from './festival-details/festival-details.component';
import { MyReferralsComponent } from './my-referrals/my-referrals.component';
import { FAQComponent } from './faq/faq.component';
import { CoursesComponent } from './courses/courses.component';
import { CourseDetailsComponent } from './course-details/course-details.component';
import { ChapterDetailsComponent } from './chapter-details/chapter-details.component';
import { ExamComponent } from './exam/exam.component';
import { MyCartComponent } from './my-cart/my-cart.component';
import { TransactionsComponent } from './transactions/transactions.component';
import {ProgressBarModule} from 'primeng/progressbar';
import { MyCoursedetailsComponent } from './my-coursedetails/my-coursedetails.component';
import { MasterCourseComponent } from './master-course/master-course.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { AboutComponent } from './about/about.component';
import { ContactComponent } from './contact/contact.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { TrainerProfileComponent } from './trainer-profile/trainer-profile.component';
import { SafePipe } from './safe.pipe';
import { NgxSpinnerModule } from 'ngx-spinner';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    StudentProfileComponent,
    MyCourseComponent,
    LoginComponent,
    RegisterComponent,
    HomeComponent,
    StudentLearningComponent,
    StudentEnrollComponent,
    StudentDashboardComponent,
    RazorpayPaymentComponent,
    MyProfileComponent,
    NotificationComponent,
    PrivacyPolicyComponent,
    FestivalDetailsComponent,
    MyReferralsComponent,
    FAQComponent,
    CoursesComponent,
    CourseDetailsComponent,
    ChapterDetailsComponent,
    ExamComponent,
    MyCartComponent,
    TransactionsComponent,
    MyCoursedetailsComponent,
    MasterCourseComponent,
    PaymentConfirmationComponent,
    SearchResultsComponent,
    AboutComponent,
    ContactComponent,
    AssessmentComponent,
    TermsConditionsComponent,
    TrainerProfileComponent,
    SafePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CarouselModule,
    ButtonModule,
    AccordionModule,
    BrowserAnimationsModule,
    CountToModule,
    FormsModule,
    HttpClientModule,
    ProgressBarModule,
    DialogModule,
    TabViewModule,
    CheckboxModule,
    RadioButtonModule,
    SelectButtonModule,
    TableModule,
    CalendarModule,
    PrimengCalender,
    DropdownModule,
    ScrollToModule,
    LightboxModule,
    // ClipboardModule,
    InputTextModule,
    NgxSpinnerModule,
    RatingModule,
    ToastModule,
    
    // CalendarModule.forRoot({
    //   provide: DateAdapter,
    //   useFactory: adapterFactory,
    // }),
   
    
  ],
  providers: [SessionClient,MessageService,DatePipe,Title,
    { provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi : true},
      HTTPStatus,Meta

  ],
  
  bootstrap: [AppComponent]
})
export class AppModule { }
